import { axiosInstance } from '../../../shared/api';

export function getAccessToken() {
	const data = localStorage.getItem('accessToken');
	const response = data;
	return response;
}

const accessToken = getAccessToken();

export async function expensesGerCategoriesRequest() {
	try {
		const response = await axiosInstance.get(`expenses/categories`, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get model info: ${error.message}`);
	}
}

export async function expensesCreateRequest(userData) {
	try {
		const response = await axiosInstance.post(`expenses/expenses`, userData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

/**
 * @param {object} [params]
 * @param {number} [params.offset]
 * @param {number} [params.limit]
 * @param {string[]} [params.categoryIds]
 * @param {string} [params.startDate]
 * @param {string} [params.endDate]
 */
export async function getExpensesRequest(params = {}) {
	try {
		const search = new URLSearchParams();
		search.set('offset', String(params.offset ?? 0));
		search.set('limit', String(params.limit ?? 1000));
		if (params.startDate) search.set('start_date', params.startDate);
		if (params.endDate) search.set('end_date', params.endDate);
		if (params.categoryIds?.length) {
			params.categoryIds.forEach(id => search.append('category_ids', id));
		}
		const qs = search.toString();
		const url = `expenses/expenses${qs ? `?${qs}` : ''}`;
		const response = await axiosInstance.get(url, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get model info: ${error.message}`);
	}
}

export async function expensesUpdateRequest(expenseId, userData) {
	try {
		const response = await axiosInstance.put(
			`expenses/expenses/${expenseId}`,
			userData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function expensesDeleteRequest(expenseId) {
	try {
		const response = await axiosInstance.delete(
			`/expenses/expenses/${expenseId}`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200 || response.status === 204) {
			return response;
		}
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function recurringExpensesCreateRequest(userData) {
	try {
		const response = await axiosInstance.post(`recurring-expenses`, userData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function getRecurringExpensesRequest() {
	try {
		const response = await axiosInstance.get(
			`recurring-expenses?skip=0&limit=100&is_active=true`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get recurring expenses: ${error.message}`);
	}
}

export async function recurringExpensesUpdateRequest(
	recurringExpenseId,
	userData,
) {
	try {
		const response = await axiosInstance.put(
			`recurring-expenses/${recurringExpenseId}`,
			userData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function recurringExpensesDeleteRequest(recurringExpenseId) {
	try {
		const response = await axiosInstance.delete(
			`recurring-expenses/${recurringExpenseId}`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200 || response.status === 204) {
			return response;
		}
	} catch (error) {
		console.error(error);
		throw error;
	}
}
